<div class="qr-based-content">
  <div class="qr-based-content-wrapper">
    <app-api-state-wrapper [isLoading]="isLoading" [isError]="isError" [errorMessage]="errorMessage"
      [errorDetails]="errorDetails" (retry)="refreshPreview()" (refreshPage)="refreshPage()">
      @if (isSuccess) {
      <app-survey-exit-screen [questionnaire]="questionnaire" [showReviewRedirection]="showReviewRedirection"
        mode="success" (createQuestionnaireClick)="backToHome()" />
      } @else if (isDuplicateResponse) {
      <app-survey-exit-screen [questionnaire]="questionnaire" mode="duplicate" />
      } @else {
      <!-- Welcome Screen Done -->
      @if (hasWelcomeScreen() && !welcomeScreenShown) {
      <app-survey-welcome-screen [questionnaire]="questionnaire" (startClick)="onWelcomeStart()" />
      }
      @else {
      <div class="qr-based-survey-layout">
        <!-- Header done -->
        <app-survey-header [questionnaire]="questionnaire" />
        <div class="qr-based-survey-layout-content">
          <!-- page section done -->
          @if (currentPage > 0) {
          <app-survey-page-section [questionnaire]="questionnaire" [currentPage]="currentPage" />
          }
          <app-reusable-question-components [organizationId]="organizationId" [questionnaireId]="questionnaireId"
            [questionnaire]="questionnaire" (onSubmitAnswers)="onSubmitAnswers($event)"
            (currentPageChange)="onCurrentPageChange($event)" [isSubmitting]="isSubmitting" [skipWelcomeScreen]="true"
            [hideDuplicateResponse]="true" />
        </div>
        <!-- footer done -->
        <app-survey-footer [questionnaire]="questionnaire" />
      </div>
      }
      }
    </app-api-state-wrapper>
  </div>
</div>